// ✅ Funkcija za setovanje sortiranja iz Redux-a / State-a
export const handleSetSorters = (sorters, table) => {
  if (table && typeof table.setSort === 'function') {
    table.setSort(sorters.map((item) => ({ ...item, column: item.field }))); // Postavljanje sortiranja u Tabulator
  } else {
    console.error('Tabela nije inicijalizovana.');
  }
};
